import { APIError } from './errors';

export default {
  async fetchFromAPI(url) {
    const response = await fetch(url);
    const data = await response.json();

    if(!response.ok) {
      throw new APIError(data);
    }

    return data;
  }
};
